import jwtDecode from "jwt-decode";
import * as UserRepository from "repository/UserRepository";

export const getUser = async () => {
    try {
        const token = await UserRepository.getToken();

        const {id} = jwtDecode(token)

        const user = await UserRepository.getUser(id);
        const stats = await UserRepository.getUserStats();
        const subscription = await UserRepository.getUserSubscriptions();

        return {...user, stats, plan: subscription?.subscriptionPlan.name}
    } catch(error) {
        console.log(error)
    }
};